// extracted by mini-css-extract-plugin
export default {"row":"DesktopTabs_row__ZDJ28","col":"DesktopTabs_col__7ykRi","left":"DesktopTabs_left__+bLIN","right":"DesktopTabs_right__VAjn0"};